// extracted by mini-css-extract-plugin
export var editButton = "_q2-0";